import { authApi } from "./api";
import { Validation } from "./validation";
import { Notifications } from "./notifications";
import {trackException} from "./errors";

const ThemeBuilder = function() {
    let container, saveButton, discardButton, revertButton, primaryColorEl, secondaryColorEl, navigationBgColorEl, headerBgColorEl, pageBgColorEl;

    const handleSaveClick = async e => {
        e.preventDefault();

        try {
            Validation.disableButton(saveButton);

            await authApi.put("/api/theme", {
                primaryColor: primaryColorEl.value,
                secondaryColor: secondaryColorEl.value,
                navigationBgColor: navigationBgColorEl.value,
                headerBgColor: headerBgColorEl.value,
                // pageBgColor: pageBgColorEl.value,
            });

            Notifications.setNotificationCookie("The theme has been applied and is now active.");
            location.reload();
        } catch(err){
            trackException(err);
            Validation.enableButton(saveButton);
            Notifications.showError({ message: "There was a problem saving the theme." })
        }
    }

    const handleDiscardClick = async e => {
        e.preventDefault();

        Notifications.confirm.fire({text: "Are you sure you want to discard the current changes?"})
            .then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        location.reload();
                    } catch (err) {
                        trackException(err);
                        Validation.enableButton(revertButton);
                        Notifications.showError({ message: "There was a problem saving the theme." })
                    }
                }
            });
    }

    const handleRevertClick = async e => {
        e.preventDefault();

        Notifications.confirm.fire({text: "Are you sure you want to revert the theme to the default? The current colours will be reset and cannot be undone."})
            .then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        Validation.disableButton(revertButton);

                        await authApi.delete("/api/theme");

                        Notifications.setNotificationCookie("The theme has been reset to the default.");
                        location.reload();
                    } catch (err) {
                        trackException(err);
                        Validation.enableButton(revertButton);
                        Notifications.showError({ message: "There was a problem saving the theme." })
                    }
                }
            });
    }

    const primaryColorSelectors = ["--bs-primary", "--bs-primary-rgb", "--bs-link-color", "--bs-text-primary", "--bs-menu-link-color-hover", "--bs-menu-link-color-show", "--bs-menu-link-color-here", "--bs-menu-link-color-active", "--bs-link-color-rgb", "--bs-component-active-bg", "--bs-link-hover-color-rgb"];
    const secondaryColorSelectors = ["--bs-secondary", "--bs-secondary-rgb", "--bs-text-secondary"];
    const navigationBgColorSelectors = ["--bs-app-header-base-bg-color", "--bs-app-header-sticky-bg-color"];
    const headerBgColorSelectors = ["--bs-app-toolbar-bg"];


    const handleColorChange = e => {

        switch(e.target.id.toLowerCase()) {
            case "primarycolor":
                updateColor(primaryColorSelectors, e.target.value);
                break;
            case "secondarycolor":
                updateColor(secondaryColorSelectors, e.target.value);
                break;
            case "navigationbgcolor":
                updateColor(navigationBgColorSelectors, e.target.value);
                break;
            case "headerbgcolor":
                updateColor(headerBgColorSelectors, e.target.value);
                break;
        }
    }

    const updateColor = (selectors, color) => {
        selectors.forEach(el => {
            document.documentElement.style.setProperty(el, color);
        });
    }

    return {
        init: function () {
            container = document.getElementById("theme_builder");
            if (!container)
                return;

            primaryColorEl = container.querySelector("#PrimaryColor");
            secondaryColorEl = container.querySelector("#SecondaryColor");
            navigationBgColorEl = container.querySelector("#NavigationBgColor");
            headerBgColorEl = container.querySelector("#HeaderBgColor");
            pageBgColorEl = container.querySelector("#PageBgColor");

            saveButton = container.querySelector("#theme_builder_submit");
            saveButton.addEventListener("click", handleSaveClick);

            discardButton = container.querySelector("#theme_builder_discard");
            discardButton.addEventListener("click", handleDiscardClick);

            revertButton = container.querySelector("#theme_builder_revert");
            revertButton.addEventListener("click", handleRevertClick);

            container.querySelectorAll("input[type='color']").forEach(el => {
                el.addEventListener("change", handleColorChange);
            });
        }
    };
}();

export default ThemeBuilder;
